import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Mutation } from '@apollo/react-components';
import routes from '@achievable-me/tundra-wizard/routes';
import { PropsRoute } from '$components/Routes';
import { TOGGLE_SIDEBAR_EXPANDED } from '$queries/chrome';
import Sidenav from '$components/layout/ProductLayout/Sidenav';
import NotFound from '$components/NotFound';
import StaffDashboard from '$components/staff/StaffDashboard';
import Organizations from '$components/staff/Organizations';
import Products from '$components/staff/Products';
import Users from '$components/staff/Users';
import Grants from '$components/staff/admin/Grants';
import OrganizationOverview from '$components/staff/OrganizationOverview';
import PartnerCharges from '$components/staff/PartnerCharges';
import PromoCodes from '$components/staff/admin/PromoCodes';
import ProductContent from '$components/staff/ProductContent';
import ProductFlashcards from '$components/staff/ProductFlashcards';
import ProductOverview from '$components/staff/ProductOverview';
import System from '$components/staff/admin/System';
import styles from './styles.scss';

class StaffLayout extends Component {
  state = {
    collapsed: false,
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  render() {
    const { currentUser, location, match } = this.props;

    return (
      <Mutation mutation={TOGGLE_SIDEBAR_EXPANDED}>
        {(toggleSidebarExpanded) => (
          <div className={styles.layout}>
            <Sidenav
              currentUser={currentUser}
              toggleSidebarExpanded={toggleSidebarExpanded}
              location={location}
              match={match}
              mode="staff"
            />
            <div data-aaa="staffLayoutContent" className={styles.content}>
              <div
                data-aaa="navBars"
                className={styles.bars}
                onClick={toggleSidebarExpanded}
              >
                <i className="fas fa-bars" />
              </div>
              <Switch>
                <PropsRoute
                  exact
                  path={routes.staff.dashboard}
                  component={StaffDashboard}
                  currentUser={currentUser}
                />
                <Route exact path={routes.staff.products} component={Products} />
                <Route exact path={routes.staff.grants} component={Grants} />
                <Route
                  exact
                  path={routes.staff.organizations}
                  component={Organizations}
                />
                <Route exact path={routes.staff.promoCodes} component={PromoCodes} />
                <Route exact path={routes.staff.system} component={System} />
                <PropsRoute
                  exact
                  path={routes.staff.users}
                  component={Users}
                  currentUser={currentUser}
                />
                <Route exact path={routes.staff.charges} component={PartnerCharges} />
                <Route
                  exact
                  path={routes.staff.organization.overview}
                  component={OrganizationOverview}
                />
                <Route
                  exact
                  path={routes.staff.product.overview}
                  component={ProductOverview}
                />
                <Route
                  path={routes.staff.product.content.overview}
                  component={ProductContent}
                />
                <Route
                  path={routes.staff.product.flashcards}
                  component={ProductFlashcards}
                />

                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
        )}
      </Mutation>
    );
  }
}

export default StaffLayout;
